import { adminMutation } from "@/admin/utils/adminMutation.ts";
import { queryKey } from "@/modules/metal/metalOsQuery.ts";
import { jsonEncodedBody } from "@/utils/fetchClient.ts";
import type {
    MetalOsCreate,
    MetalOsTypeCreate,
    MetalOsTypeUpdate,
    MetalOsUpdate,
} from "@warrenio/api-spec/spec.oats.gen";

//#region Operating System mutations

const entity = "Operating System";

export const osCreateMutation = adminMutation((apiClient) => ({
    entity,
    operation: "create",
    requestFn: async ({ body }: { body: MetalOsCreate }) =>
        await apiClient.POST("/admin/metal/os", { ...jsonEncodedBody, body }),
    invalidateQueryKey: queryKey,
}));

export const osUpdateMutation = adminMutation((apiClient) => ({
    entity,
    operation: "update",
    requestFn: async ({ body, os_id }: { body: MetalOsUpdate; os_id: string }) =>
        await apiClient.PATCH("/admin/metal/os/{os_id}", { ...jsonEncodedBody, body, params: { path: { os_id } } }),
    invalidateQueryKey: queryKey,
}));

export const osDeleteMutation = adminMutation((apiClient) => ({
    entity,
    operation: "delete",
    requestFn: async ({ os_id }: { os_id: string }) =>
        await apiClient.DELETE("/admin/metal/os/{os_id}", { params: { path: { os_id } } }),
    invalidateQueryKey: queryKey,
}));

//#endregion

//#region Operating System Type mutations

const osTypeEntity = "Operating System Type";

export const osTypeCreateMutation = adminMutation((apiClient) => ({
    entity: osTypeEntity,
    operation: "create",
    requestFn: async ({ body }: { body: MetalOsTypeCreate }) =>
        await apiClient.POST("/admin/metal/os_types", { ...jsonEncodedBody, body }),
    invalidateQueryKey: queryKey,
}));

export const osTypeUpdateMutation = adminMutation((apiClient) => ({
    entity: osTypeEntity,
    operation: "update",
    requestFn: async ({ body, os_type_id }: { body: MetalOsTypeUpdate; os_type_id: string }) =>
        await apiClient.PATCH("/admin/metal/os_types/{os_type_id}", {
            ...jsonEncodedBody,
            body,
            params: { path: { os_type_id } },
        }),
    invalidateQueryKey: queryKey,
}));

export const osTypeDeleteMutation = adminMutation((apiClient) => ({
    entity: osTypeEntity,
    operation: "delete",
    requestFn: async ({ os_type_id }: { os_type_id: string }) =>
        await apiClient.DELETE("/admin/metal/os_types/{os_type_id}", { params: { path: { os_type_id } } }),
    invalidateQueryKey: queryKey,
}));
//#endregion
